import { FirstName, LastName, Phone, EmailAddress, Country, CountryMenu, Address, TownCity, StateCountry, PostalCode, CheckMeOut, PlaceOrder, LastNameRequired, FirstNameRequired, PhoneRequired, EmailRequired, AddressRequired, CityRequired, StateRequired, PincodeRequired, CheckoutRequired } from "../../../../Constant";
import { Btn, P } from "../../../../AbstractElements";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

const CheckoutTableData = () => {
  const navigate = useNavigate();
  const {register,handleSubmit,formState: { errors }} = useForm();
  const onSubmit = (data: any) => {
    if (data !== "") {
      alert("You submitted the form and stuff!");
      navigate(`${process.env.PUBLIC_URL}/ECommerce/Invoice`);
    }
  };
  return (
    <Col xl="6" sm="12">
      <Form onSubmit={handleSubmit(onSubmit)} className="form-bookmark needs-validation">
        <Row>
          <Col sm="6" className="mb-3">
            <Label check>{FirstName}</Label>
            <input className="form-control" type="text" {...register("firstName", { required: true })} />
            {errors.firstName && <span className="text-danger">{FirstNameRequired}</span>}
          </Col>
          <Col sm="6">
            <Label check>{LastName}</Label>
            <input className="form-control" type="text" {...register("lasName", { required: true })} />
            {errors.lastName && <span className="text-danger">{LastNameRequired}</span>}
          </Col>
        </Row>
        <Row>
          <Col sm="6" className="mb-3">
            <Label check>{Phone}</Label>
            <input className="form-control" type="number" {...register("phone", { required: true })} />
            {errors.phone && <span className="text-danger">{PhoneRequired}</span>}
          </Col>
          <Col sm="6">
            <Label check>{EmailAddress}</Label>
            <input className="form-control" type="text" {...register("email", { required: true, pattern: /^\S+@\S+$/i })} />
            {errors.email && <span className="text-danger">{EmailRequired}</span>}
          </Col>
        </Row>
        <FormGroup>
          <Label check>{Country}</Label>
          <Input type="select" name="selectMulti">{CountryMenu.map((items, i) => (<option key={i}>{items}</option>))}</Input>
        </FormGroup>
        <FormGroup>
          <Label for="inputAddress5" check>{Address}</Label>
          <input className="form-control" type="text" {...register("address", { required: true, min: 20, max: 120 })} />
          {errors.address && <span className="text-danger">{AddressRequired}</span>}
        </FormGroup>
        <FormGroup>
          <Label for="inputCity" check>{TownCity}</Label>
          <input className="form-control" type="text" {...register("city", { required: true })} />
          {errors.city && <span className="text-danger">{CityRequired}</span>}
        </FormGroup>
        <FormGroup>
          <Label for="inputAddress2" check>{StateCountry}</Label>
          <input className="form-control" type="text" {...register("state", { required: true })} />
          {errors.state && <span className="text-danger">{StateRequired}</span>}
        </FormGroup>
        <FormGroup>
          <Label for="inputAddress6" check>{PostalCode}</Label>
          <input className="form-control" type="text" {...register("pincode", { pattern: /\d+/ })} />
          {errors.pincode && <span className="text-danger">{PincodeRequired}</span>}
        </FormGroup>
        <FormGroup>
          <div className="form-check">
            <input type="checkbox" className="form-check-input" {...register("chech", { required: true })} />
            <Label check className="m-0">{CheckMeOut}</Label>
           {errors.chech &&  <P className="text-danger mt-0">{CheckoutRequired}</P>}
          </div>
        </FormGroup>
        <div className="text-end order-place mb-3">
          <Btn color="primary">{PlaceOrder}</Btn>
        </div>
      </Form>
    </Col>
  );
};
export default CheckoutTableData;
